import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AddCircle16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_247)'>
      <path
        d='M7.25 11.5V8.75H4.5V7.25H7.25V4.5H8.75V7.25H11.5V8.75H8.75V11.5H7.25Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 0.25C3.71979 0.25 0.25 3.71979 0.25 8C0.25 12.2802 3.71979 15.75 8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71979 12.2802 0.25 8 0.25ZM1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C4.54822 14.25 1.75 11.4518 1.75 8Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_247'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

AddCircle16.displayName = 'AddCircle16';
export default AddCircle16;
